"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinchZoomingState = void 0;
const rc_js_util_1 = require("rc-js-util");
const e_pointer_event_type_1 = require("../internal-events/e-pointer-event-type");
const get_distance_between_pointer_events_1 = require("../util/get-distance-between-pointer-events");
const get_center_between_pointer_events_1 = require("../util/get-center-between-pointer-events");
/**
 * Allows for panning as well as zooming.
 */
class PinchZoomingState {
    constructor(firstFingerDownEvent, secondFingerDownEvent, options, providers, sharedState) {
        this.firstFingerDownEvent = firstFingerDownEvent;
        this.secondFingerDownEvent = secondFingerDownEvent;
        this.options = options;
        this.providers = providers;
        this.sharedState = sharedState;
        this.cssCenterPoint = new rc_js_util_1.Vec2.f32();
        const distanceBetweenPointerEvents = (0, get_distance_between_pointer_events_1.getDistanceBetweenPointerEvents)(firstFingerDownEvent.$event, secondFingerDownEvent.$event);
        // remove possibility of zeros
        this.initialDistance = rc_js_util_1._Math.max(distanceBetweenPointerEvents, 1);
        (0, get_center_between_pointer_events_1.getCenterBetweenPointerEvents)(firstFingerDownEvent, secondFingerDownEvent, this.cssCenterPoint);
        this.providers.callbacks.onPanZoomStart(this.cssCenterPoint, this.initialDistance);
    }
    handleMouseEvent() {
        return null;
    }
    handlePointerEvent(eventType, chartEvent) {
        DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => {
            rc_js_util_1._Debug.assert(this.firstFingerDownEvent !== chartEvent, "event must be cloned");
            rc_js_util_1._Debug.assert(this.secondFingerDownEvent !== chartEvent, "event must be cloned");
        });
        this.updateEvents(chartEvent);
        (0, get_center_between_pointer_events_1.getCenterBetweenPointerEvents)(this.firstFingerDownEvent, this.secondFingerDownEvent, this.cssCenterPoint);
        switch (eventType) {
            case e_pointer_event_type_1.EPointerEventType.Out:
            case e_pointer_event_type_1.EPointerEventType.Up:
                {
                    return rc_js_util_1._Fp.valueOrNull(this.isInitialPointer(chartEvent), this.providers.stateFactories.getPanningState(this.getRemainingEvent(chartEvent), this.options, this.providers, this.sharedState));
                }
            case e_pointer_event_type_1.EPointerEventType.Down:
                // don't support touch support for more than 2 fingers
                return null;
            case e_pointer_event_type_1.EPointerEventType.Move:
                {
                    if (this.isInitialPointer(chartEvent)) {
                        const distanceBetweenPointerEvents = (0, get_distance_between_pointer_events_1.getDistanceBetweenPointerEvents)(this.firstFingerDownEvent.$event, this.secondFingerDownEvent.$event);
                        // remove possibility of divide by 0
                        const currentDistance = rc_js_util_1._Math.max(distanceBetweenPointerEvents, 1);
                        this.providers.callbacks.onPanZoomChange(chartEvent, this.cssCenterPoint, currentDistance);
                    }
                    return null;
                }
        }
        return rc_js_util_1._Production.assertValueIsNever(eventType);
    }
    updateEvents(chartEvent) {
        if (this.firstFingerDownEvent.$event.pointerId === chartEvent.$event.pointerId) {
            this.firstFingerDownEvent = chartEvent.clone();
        }
        else if (this.secondFingerDownEvent.$event.pointerId === chartEvent.$event.pointerId) {
            this.secondFingerDownEvent = chartEvent.clone();
        }
    }
    isInitialPointer(chartEvent) {
        return this.firstFingerDownEvent.$event.pointerId === chartEvent.$event.pointerId
            || this.secondFingerDownEvent.$event.pointerId === chartEvent.$event.pointerId;
    }
    getRemainingEvent(chartEvent) {
        return this.firstFingerDownEvent.$event.pointerId === chartEvent.$event.pointerId
            ? this.secondFingerDownEvent
            : this.firstFingerDownEvent;
    }
}
exports.PinchZoomingState = PinchZoomingState;
//# sourceMappingURL=pinch-zooming-state.js.map